import { useState, useEffect, useContext } from "react"
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import Fade from '@mui/material/Fade';
import Grow from '@mui/material/Grow';
import { alpha, useTheme } from '@mui/material';
import LogInIcon from '@mui/icons-material/Login';

import { useNavigate } from "react-router-dom"

import { AuthContext } from '../../AuthContext';
import { loginUrl } from './microsoftLogin';

import MicrosoftIcon from '../../media/microsoft.png'
import ImageHello from "../../media/Lamp.png"
function SignIn () {
    const theme = useTheme();
    const [errmsg, setErrMsg] = useState();
    const [isloading, setIsLoading] = useState(true);
    const { isAuthenticated, getUser } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const onLogin = () => {
        setIsLoading(true)
        const returnPageUrl = new URL(window.location.href).searchParams.get('returnUrl'); // Get returnUrl from query string
        window.location.href = loginUrl(returnPageUrl || '/home')
    }

    useEffect(() => {
        if(isAuthenticated()){
            const user = getUser()
            sessionStorage.setItem('account',user.accounts[0]);
            navigate("/home")
        }
        setIsLoading(false);
    }, []); 

    return(
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: theme.palette.mode === 'dark'
                    ? `linear-gradient(135deg, ${alpha(theme.palette.background.default, 0.95)} 0%, ${alpha(theme.palette.primary.main, 0.1)} 50%, ${alpha(theme.palette.secondary.main, 0.1)} 100%)`
                    : `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.background.default, 0.95)} 30%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
                transition: 'background 0.3s ease',
            }}
        >
            <Container component="main" maxWidth="xs">
                <Fade in timeout={800}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 5,
                            background: theme.palette.mode === 'dark'
                                ? alpha(theme.palette.background.paper, 0.8)
                                : alpha(theme.palette.background.paper, 0.95),
                            backdropFilter: 'blur(20px)',
                            border: `1px solid ${alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.1 : 0.2)}`,
                            borderRadius: 4,
                            boxShadow: theme.palette.mode === 'dark'
                                ? `0 8px 32px ${alpha(theme.palette.common.black, 0.4)}`
                                : `0 8px 32px ${alpha(theme.palette.common.black, 0.12)}`,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Grow in timeout={1000}>
                                <Box
                                    sx={{
                                        width: 100,
                                        height: 100,
                                        borderRadius: 3,
                                        overflow: 'hidden',
                                        mb: 3,
                                        boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.2)}`,
                                        border: `3px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.secondary.main, 0.1)} 100%)`,
                                    }}
                                >
                                    <img
                                        width="85"
                                        height="85"
                                        src={ImageHello}
                                        alt="Logo"
                                        style={{ objectFit: 'contain' }}
                                    />
                                </Box>
                            </Grow>

                            <Typography
                                component="h1"
                                variant="h4"
                                sx={{
                                    fontWeight: 700,
                                    mb: 1,
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                Welcome Back
                            </Typography>

                            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                                Sign in to My CMA
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={onLogin}
                                fullWidth
                                size="large"
                                startIcon={<img width={23} src={MicrosoftIcon} alt="Microsoft Logo" />}
                                sx={{
                                    py: 1.5,
                                    mb: 2,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.4)}`,
                                    '&:hover': {
                                        boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                                    },
                                }}
                            >
                                Sign In With Microsoft
                            </Button>

                            {isloading && (
                                <Box sx={{ width: '100%', mt: 1 }}>
                                    <LinearProgress />
                                </Box>
                            )}

                            {errmsg && (
                                <Fade in>
                                    <Paper
                                        sx={{
                                            mt: 2,
                                            p: 2,
                                            width: '100%',
                                            background: alpha(theme.palette.error.main, 0.1),
                                            border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
                                            borderRadius: 2,
                                        }}
                                    >
                                        <Typography variant="body2" color="error.main">
                                            {errmsg}
                                        </Typography>
                                    </Paper>
                                </Fade>
                            )}
                        </Box>
                    </Paper>
                </Fade>
            </Container>
        </Box>
    )
}

export default SignIn